import React from 'react';

import SEOMeta from '@src/components/SEOMeta';

export default function TermsOfUsePage() {
  return (
    <>
      <SEOMeta title="利用規約" description="ICHI-INの利用規約ページです。" />
      <div className="mx-auto max-w-[1000px] bg-white rounded-lg">
        <div className="py-4 m-6">
          <div className="my-6">
            <h1 className="my-8 text-3xl text-center">利用規約</h1>
            <p>
              この利用規約（以下、「本規約」といいます。）は、株式会社Ojiiy（以下、「当社」といいます。）がこのウェブサイト上で提供するイチイン（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従いサービスを利用して頂きます。
            </p>
            <p>
              当社は、ユーザーが「本サービス」を利用した場合、当該ユーザーが本規約に同意したものとみなします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第1条（適用）</h2>
            <p>
              本規約は、ユーザーと当社の間の本サービスに関わる一切の関係に適用されるものとします。
            </p>
            <p>
              当社は本サービスに関して、本規約以外に、利用する際のルール、個別の定め（以下、「個別規定」といいます。）をする場合がございます。これら個別規定はその名称に関わらず、本規約の一部とみなします。
            </p>
            <p>
              本規約の内容が、個別規定と矛盾している場合には、特段の定めがない限り、
              個別規定が優先されるものとします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第2条（利用登録）</h2>
            <ul className="ml-4 list-disc">
              <li>
                本サービスにおいて、利用登録者が本規約の内容に同意の上で、当社の定める方法に従って利用登録を申請したのち、当社が登録の可否を決定し、利用登録が完了します。
              </li>
              <li>
                利用登録の申請者に以下の事由があると当社が判断した場合、利用登録の承認をしない場合があり、その理由に関しては一切開示義務は負いません。
              </li>
              <li>利用登録の申請に関して、虚偽の内容または不備があった場合</li>
              <li>
                当社サービス内において違反したことのある申請者または関係者の場合
              </li>
              <li>
                暴力団、暴力団員、暴力団準構成員、暴力団関係者、総会屋その他の反社会的勢力（以下、まとめて「反社会的勢力」という）に属するまたは関与していると当社が判断した場合
              </li>
              <li>その他、当社において利用登録が相当でないと判断した場合</li>
            </ul>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">
              第3条（ユーザーIDおよびパスワードの管理）
            </h2>
            <ul className="ml-4 list-disc">
              <li>
                ユーザーは、自己責任において、本サービスにおけるユーザーID及びパスワードを適切に管理するものとします。
              </li>
              <li>
                ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与、第三者との共用はできません。
              </li>
              <li>
                当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致している場合にのみ、そのユーザーIDを登録しているユーザー自身の利用とみなします。
              </li>
              <li>
                ユーザーID及びパスワードが第三者によって使用され生じた損害等に関しては、当社は一切責任を負いません。ただし当社の故意又は過失があった場合には除きます。
              </li>
            </ul>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第4条（利用料金および支払方法）</h2>
            <ul className="ml-4 list-disc">
              <li>
                2021年7月現在は無料で利用いただけますが、今後何かしらの形で利用料金を頂く予定です。その際は通知及びサービス利用の継続可否を伺います。
              </li>
              <li>
                支払いは本サービス内の決済サービスを利用するものとします。
              </li>
            </ul>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第5条（禁止事項）</h2>
            <p>
              ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
            </p>
            <ul className="ml-4 list-disc">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>
                ユーザーの情報等、本サービスに含まれる著作権、商標権ほか知的財産権・プラーバシーの権利・名誉その他の権利を侵害する行為
              </li>
              <li>
                当社、本サービスのユーザーのサーバーまたはネットワークの機能を破壊したり、妨害する行為
              </li>
              <li>
                当社のサービスを経由せずに、ユーザー同士が直接取引する行為
              </li>
              <li>サービスの運営を破壊・妨害する行為</li>
              <li>不正にアクセスする行為またはこれを試みる行為</li>
              <li>
                サービス内外に関わらずユーザーに関する個人情報を収集または蓄積する行為
              </li>
              <li>
                不当な目的や本サービスの目的と異なる目的を持って、本サービスを利用する行為
              </li>
              <li>
                本サービスの他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為
              </li>
              <li>事実無根のレビューを行う行為</li>
              <li>他のユーザーに成りすます行為</li>
              <li>
                当社が許諾しない本サービス上での宣伝、広告、勧誘、または営業行為
              </li>
              <li>面識のない異性との出会いを目的とした行為</li>
              <li>ゲスト、ホストの了承なくSNS等に掲載する行為</li>
              <li>反社会的勢力等への利益供与</li>
              <li>
                当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
              </li>
              <li>その他、当社が不適切と判断する行為</li>
            </ul>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第6条（本サービスの提供の停止等）</h2>
            <p>
              当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前通知することなくサービスの全部または一部を停止することができるとします。
            </p>
            <ul className="ml-4 list-disc">
              <li>
                本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
              </li>
              <li>コンピュータまたは通信回線等が事故により停止した場合</li>
              <li>
                地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
              </li>
              <li>その他、当社が本サービスの提供が困難と判断した場合</li>
            </ul>
            <p>
              当社は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第7条（利用制限および登録抹消）</h2>
            <p>
              当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
            </p>
            <ul className="ml-4 list-disc">
              <li>本規約のいずれかの条項に違反した場合</li>
              <li>登録事項に虚偽の事実があることが判明した場合</li>
              <li>料金等の支払債務の不履行があった場合</li>
              <li>当社からの連絡に対し、一定期間返答がない場合</li>
              <li>本サービスについて、最終の利用から一定期間利用がない場合</li>
              <li>その他、当社が本サービスの利用を適当でないと判断した場合</li>
            </ul>
            <p>
              当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第8条（退会）</h2>
            <p>
              ユーザーは当社の定める退会手続きにより、本サービスから退会できるものとします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第9条（保証の否認および免責事項）</h2>
            <p>
              当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
            </p>
            <p>
              当社は、本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。ただし、本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
            </p>
            <p>
              前項ただし書に定める場合であっても、当社は、当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）について一切の責任を負いません。また、当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害の賠償は、ユーザーから当該損害が発生した月に受領した利用料の額を上限とします。
            </p>
            <p>
              当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第10条（サービス内容の変更等）</h2>
            <p>
              当社は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第11条（利用規約の変更）</h2>
            <p>
              当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、本サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第12条（個人情報の取扱い）</h2>
            <p>
              当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第13条（通知または連絡）</h2>
            <p>
              ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社は、ユーザーから、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第14条（権利義務の譲渡の禁止）</h2>
            <p>
              ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
            </p>
          </div>

          <div className="my-4">
            <h2 className="my-2 text-xl">第15条（準拠法・裁判管轄）</h2>
            <p>本規約の解釈にあたっては、日本法を準拠法とします。</p>
            <p>
              本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
